import React, { useState, useEffect } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { Grid, MenuItem, TextField } from '@material-ui/core';

import { actions, merchantActions } from '../../../redux/merchants';
import { CalendarPick } from './CalendarPicker';

const Filter = ({ location }) => {
	const { filter, user, merchants, isCalendarLoading } = useSelector(
		state => ({
			filter: state.merchants.filter,
			isCalendarLoading: state.merchants.isCalendarLoading,
			user: state.auth.user,
			merchants: state.merchants.merchants,
		}),
		shallowEqual,
	);
	const { from, to } = filter;

	const [currTo, setCurrTo] = useState('')
	const [currFrom, setCurrFrom] = useState('')
	const [hideMerchantAll, setHideMerchantAll] = useState(false)

	const routesNotToFilterAll = ['/posts', '/moderation', '/feed', '/challenges', '/story'];

	const dispatch = useDispatch();

	useEffect(() => {
		setCurrFrom(from)
		setCurrTo(to)
	}, [from, to])

	const shouldHideAll = () => {
		const routeFound = routesNotToFilterAll.find(route => route === location)
		if (routeFound && user.merchantId === 'all' && merchants.length) {
			setHideMerchantAll(true)

			if (filter.merchantId === 'all') {
				const replacerOfMerchantAll = {
					target: {
						name: 'merchantId',
						value: merchants.length && merchants[0].merchantId
					}
				}
				updateMerchant(replacerOfMerchantAll)
			}
		} else {
			setHideMerchantAll(false)
		}
	}

	useEffect(() => {
		shouldHideAll()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location, merchants])

	const updateMerchant = e => {
		const { name, value } = e.target;
		return dispatch(
			actions.updateFilter({
				...filter,
				[name]: value,
			}),
		);
	};

	const updateDates = (newFrom, newTo) => {
		setCurrFrom(newFrom)
		setCurrTo(newTo)
	};

	const onClose = () => {
		dispatch(
			actions.updateFilter({
				...filter,
				from: currFrom,
				to: currTo,
			}),
		);
		dispatch(
			merchantActions.updateLoading({
				isCalendarLoading: true
			}),
		);
	}	
	
	const locationWithoutCalendar = ['/special-users', '/users', '/ambassador']

	return merchants && merchants.length ? (
		<>
			<Grid container alignItems='flex-end'>
				<TextField
					select
					disabled={user.merchantId !== 'all'}
					value={filter.merchantId}
					variant='outlined'
					onChange={updateMerchant}
					inputProps={{
						name: 'merchantId',
						id: 'merchantId',
					}}
					label='Merchant'
					style={{ marginRight: 12, minWidth: 200 }}
				>
					{merchants.map((m) => (
						< MenuItem key={m.merchantId} style={{
							display: (m.merchantId === 'all' && hideMerchantAll) && 'none'
						}} className='text-capitalize' value={m.merchantId} >
							{m.label}
						</MenuItem>
					))}
				</TextField>
				{locationWithoutCalendar.includes(location) ? null : <CalendarPick onClose={onClose}
					start={currFrom}
					end={currTo}
					onChange={updateDates}
					isCalendarLoading={isCalendarLoading} />}
			</Grid>
		</>
	) : (
		<></>
	);
};

export default Filter;
